export default __webpack_public_path__ + "static/media/Buildingrip1.d483ccc6.svg";